import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Select,
  Modal,
  Input,
  InputNumber,
} from 'antd';
import {
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';

import './style.css';
import { ContractActions } from '../../../actions';

function CreateForm({ visible, onCancel }) {
  const { Option } = Select;
  const { confirm } = Modal;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { clientsList } = useSelector((state) => state.ClientsReducer);
  const { contract } = useSelector((state) => state.ContractsReducer);

  async function handleCreateContract(values) {
    contract.name = values.name;
    contract.plan_id = values.plan_id || 10;
    contract.crm_id = values.crm_id || 2;
    contract.is_active = values.is_active;
    contract.max_device = values.max_device;
    contract.max_active = values.max_active;
    contract.plan_type = values.plan_type || 1;
    contract.day_debit = values.day_debit || '05';
    contract.client_id = values.client_id;

    confirm({
      title: 'Confirma o cadastro do contrato ?',
      icon: <ExclamationCircleOutlined />,
      content: '',

      onOk() {
        dispatch(ContractActions.async_add_contract(contract));
      },
    });
  }

  return (
    <Modal
      title="Cadastro de contrato"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      closeIcon={<CloseCircleOutlined style={{ color: 'red' }} />}
      width={450}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleCreateContract}
        size="large"
      >

        <Form.Item
          label="Cliente"
          name="client_id"
          tooltip={{
            title: 'Selecione o cliente que o contrato está associado',
            icon: <InfoCircleOutlined />,
          }}
          rules={[
            {
              required: true,
              message: 'Informe a qual cliente este contrato será associado.',
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Selecione o Cliente"
            optionFilterProp="children"
            filterOption={
                  (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
          >
            {clientsList.map(
              (client) => (
                <Option key={client.id} value={client.id}>
                  {client.company_name}
                </Option>
              ),
            )}
          </Select>
        </Form.Item>

        <Form.Item label="Nome do Contrato" name="name">
          <Input />
        </Form.Item>

        <Form.Item
          label="Status do contrato"
          name="is_active"
          rules={[
            {
              required: true,
              message: 'Informe o estado do contrato!',
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Selecione o Cliente"
            optionFilterProp="children"
            filterOption={
                  (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
          >
            <Option key="activated-contract" value>Ativado</Option>
            <Option key="disabled-contract" value={false}>Desativado</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="CRM ID"
          name="crm_id"
          rules={[]}
        >
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>

        <Form.Item
          label="Max. dispositivos"
          name="max_device"
          tooltip={{
            title: 'Quantidade máxima de dispositivos',
            icon: <InfoCircleOutlined />,
          }}
          rules={[
            {
              required: true,
              message: 'Informe a quantidade máxima de dispositivos.',
            },
          ]}
        >
          <InputNumber style={{ width: '100%' }} min={1} max={100000} />
        </Form.Item>

        <Form.Item
          label="Max. dispositivos ativos"
          name="max_active"
          tooltip={{
            title: 'Quantidade máxima de dispositivos que podem ser ativados',
            icon: <InfoCircleOutlined />,
          }}
          rules={[
            {
              required: true,
              message: 'Informe a quatidade!',
            },
          ]}
        >
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>

        <Form.Item
          label="Tipo do plano"
          name="plan_type"
          rules={[
            {
              required: false,
              message: 'Selecione um plano.',
            },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={
                  (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
          >
            <Option key="diamond" value={1}>Diamond</Option>
            <Option key="premium" value={2}>Premium</Option>
            <Option key="gold" value={3}>Gold</Option>
            <Option key="standard" value={4}>Standard</Option>
            <Option key="starter" value={5}>Starter</Option>

          </Select>
        </Form.Item>

        {/* <Form.Item
          label="Dia de débito"
          name="day_debit"
          rules={[]}
        >
          <InputNumber style={{ width: '50%' }} min={1} max={28} />
        </Form.Item> */}

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            Cadastrar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

CreateForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CreateForm;
